import React from 'react';
import { render } from 'react-dom';
import App from './App';
import 'normalize.css';
import { GlobalStyles } from './global-styles';
import { FirebaseProvider, FirebaseQuotaProvider } from './context';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

render(
  <>
    <FirebaseProvider>
      <FirebaseQuotaProvider>
        <GlobalStyles />
        <App />
      </FirebaseQuotaProvider>
    </FirebaseProvider>
  </>,
  document.getElementById('root')
);

serviceWorkerRegistration.register();
